<template>
  <m-card913 class="content-card-913" :image="content.thumbnail">
    <template #default>
      <m-a :href="findLinkOnContent(content.abstraction)">
        <h2>{{ content.title }}</h2>
      </m-a>
    </template>
  </m-card913>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard913 from '../../Cards/Card913'
import mA from '../../Tags/A'

export default {
  name: "ContentCard913",
  components: {mCard913, mA},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  }
}
</script>

<style scoped>

</style>